// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"662":"c8d81a91","2264":"fd2308e0","6822":"bdfc0d7b","8304":"c8d81a91","9534":"06b444b6"}[chunkId] + ".chunk.css";
};